"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  angular.module("pcmCommon").factory("RouteItem", ["$rootScope", "_", "moment", "routingProfile", function ($rootScope, _, moment, routingProfile) {
    function RouteItem(name, stops, options, warnings) {
      var self = this;
      self.id = _.uniqueId();
      self.name = name || "Route " + self.id;
      self.isVisible = true;
      self.stops = stops || [];
      self.warnings = warnings || [];
      self.reportWindow = null;
      self.sortableItems = [];

      self.syncStopsToSortableItems = function (index, alwaysAddSearch) {
        var noSearchPanel = self.getSearchPanelIndex() === -1;
        self.sortableItems = [];
        _.each(self.stops, function (s, i) {
          self.sortableItems.push({ "type": "stop", "value": s });
        });
        //Do not add search panel if it was explictly removed previously
        if (noSearchPanel && !alwaysAddSearch && self.stops.length > 1) {
          return;
        } else if (index !== null && index !== undefined) {
          self.sortableItems.splice(index, 0, { "type": "search", "value": null });
        } else {
          self.sortableItems.push({ "type": "search", "value": null });
        }
        // add warnings between stops if necesary
        if (self.warnings !== []) {
          self.warnings.forEach(function (warning) {
            if (index === 0) {
              //search bar gets added at 0
              self.sortableItems.splice(warning.index + 1, 0, { "type": "warning", "value": warning.text });
            } else {
              self.sortableItems.splice(warning.index, 0, { "type": "warning", "value": warning.text });
            }
          });
        }
        //console.log("Trigger from syncStopsToSortableItems: sortableItems", self.sortableItems);
      };

      self.syncSortableItemsToStops = function () {
        self.stops = [];
        _.each(self.sortableItems, function (s, i) {
          if (s.type === "stop") {
            self.stops.push(s.value);
          }
        });
        //console.log("Trigger from:syncSortableItemsToStops, stops", self.stops);
      };

      self.getSearchPanelIndex = function () {
        return _.findIndex(self.sortableItems, function (s) {
          return s.type === "search";
        });
      };

      self.removeSortableItem = function (index) {
        self.sortableItems.splice(index, 1);
      };
      self.syncStopsToSortableItems(null, true);

      // the users modified default options are passed into this method from the one spot that currently calls this, but in the future, if more spots call into this and don't pass in the modified defaults, use the system defaults.
      self.options = options || routingProfile.getSystemDefaultOptions();

      self.uiRoutingSelection = self.options.routingType;
      self.updateRoutingSelection = function (i) {
        if (i !== self.options.routingType) {
          self.uiRoutingSelection = i;
          self.options.routingType = i;
          $rootScope.$broadcast("RunRoute", self);
        }
      };

      self.hasTime = false;
      self.uiArrDepSelection = {
        type: "None",
        datetype: "date",
        useTraffic: false,
        weekday: moment(new Date()).format("dddd"),
        date: moment(new Date()).format("M/DD/YYYY"),
        time: moment(new Date()).format("h:mm A")
      };

      self.updateArrDepTime = function () {
        self.uiArrDepSelection.time = moment(new Date()).format("h:mm A");
      };

      self.applyArrDep = function () {
        /* estimatedTimeOpts	{String} Estimated time options, format Depart(Arrive)|[DayOfWeek][SpecificDateTime]|[TimeOfDay],
            ex: Depart|Monday|18:30 to depart given day of week and time of day;
            or Arrive|2014-03-04T08:15:30-05:00 to arrive at specific date/time,
            or Arrive or Depart to arrive or depart with system time.
         */
        var data = self.uiArrDepSelection;
        var arrDepString = "";
        self.hasTime = false;
        if (data.type !== "None") {
          var tempDate;
          var tempTime;
          if (data.type === "now") {
            arrDepString += "Depart";
          } else {
            arrDepString += data.type;
            tempDate = moment(data.date, "M/DD/YYYY");
            tempTime = moment(data.time, "hh:mm A");
          }
          self.hasTime = true;
          // SWPWEB-1220; do not add timestamp if date.type = now
          if (data.type !== "now" && data.datetype === "date") {
            arrDepString += "|" + moment(tempDate).format("YYYY-MM-DD") + "T" + moment(tempTime).format("HH:mm:ssZ");
          } else if (data.type !== "now" && data.datetype === "weekday") {
            arrDepString += "|" + data.weekday + "|" + moment(tempTime).format("HH:mm");
          }

          self.hasTime = true;
        }

        self.options.estimatedTimeOpts = arrDepString;
        // console.log("estimatedTimeOpts: " + self.options.estimatedTimeOpts);
        $rootScope.$broadcast("RunRoute", self);
      };

      self.hasExpectedArrival = function () {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = self.stops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var stop = _step.value;

            if (stop.earliestArrivalTime.hasValue() || stop.latestArrivalTime.hasValue()) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return false;
      };

      self.isCalculating = false;
      self.isError = false;
      self.errorMessage = "";
      self.hasStops = function () {
        return self.stops.length > 0;
      };
      self.isValidRoute = function () {
        return self.stops.length > 1;
      };
      self.isSelectedRoute = true;
      self.isOpen = false;

      self.addStop = function (stop) {
        var index = self.getSearchPanelIndex();
        if (!Array.isArray(stop)) {
          stop = [stop];
        }

        if (index === -1) {
          var _self$stops;

          (_self$stops = self.stops).push.apply(_self$stops, _toConsumableArray(stop));
          self.syncStopsToSortableItems(null);
        } else {
          var _self$stops2;

          (_self$stops2 = self.stops).splice.apply(_self$stops2, [index, 0].concat(_toConsumableArray(stop)));
          self.syncStopsToSortableItems(index + stop.length);
        }

        self.updateStopIcons();
        self.isOpen = true;
        $rootScope.$broadcast("RunRoute", self);
      };

      self.deleteStop = function (stop) {
        //self.stops.splice(idx, 1);
        _.remove(self.stops, stop);
        self.syncStopsToSortableItems();

        self.updateStopIcons();
        $rootScope.$broadcast("RunRoute", self);
      };

      self.deleteAllStops = function () {
        self.stops = [];
        self.syncStopsToSortableItems();
      };

      self.clearTotals = function () {
        //if (self.isValidRoute()) {
        //    mapService.removeRoute();
        //}
        self.routeDistance = "";
        self.routeTime = "";
        self.routeDirections = "";
        self.routeTMiles = "";
        self.routeTHours = "";
        self.routeTTolls = "";
        self.routeTCost = "";
      };

      self.updateStopIcons = function () {
        for (var i = 0; i < self.stops.length; i++) {
          var iStyle = "waypoint";
          var iText = i.toString();
          if (i === self.stops.length - 1 && !self.options.hubRouting) {
            iStyle = "destination";
            iText = "";
          }
          if (i === 0) {
            iStyle = "origin";
            iText = "";
          }
          if (i === 0 && self.options.hubRouting) {
            iText = "";
          }

          self.stops[i].Icon = iStyle;
          self.stops[i].IconText = iText;
        }
      };

      self.setOrigStopTimes = function () {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = self.stops[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var stop = _step2.value;

            stop.origDuration = stop.duration;
            stop.origEarliestArrivalTime = angular.copy(stop.earliestArrivalTime);
            stop.origLatestArrivalTime = angular.copy(stop.latestArrivalTime);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      };

      self.revertStopTimes = function () {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = self.stops[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var stop = _step3.value;

            stop.duration = stop.origDuration;
            stop.earliestArrivalTime = stop.origEarliestArrivalTime;
            stop.latestArrivalTime = stop.origLatestArrivalTime;
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      };

      self.optimizeStops = function (results) {
        //Get new ordering of array indices, i.e. [4 2 1 3]
        var newOrdering = _.map(results.Stops, function (stop) {
          return stop.OptimizationInfo.OriginalPosition;
        });
        //console.log("REORDERING LIKE THIS:");
        //console.log(newOrdering);
        var newStops = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = newOrdering[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var newOrderIndex = _step4.value;

            newStops.push(self.stops[newOrderIndex]);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        self.stops = newStops;
        self.syncStopsToSortableItems();
        self.updateStopIcons();
      };
    }

    return RouteItem;
  }]);
})();


// WEBPACK FOOTER //
// ./app/pcm-common/RouteItem.module.js